import { arrayOf, node, oneOfType } from 'prop-types';

import { Title } from './title';
import { Description } from './description';

import styles from './Section.scss';

export const Section = ({ children = null, ...props }) => (
  <section className={styles.Section} {...props}>
    {children}
  </section>
);

Section.Title = Title;
Section.Description = Description;

Section.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
};
